var baseStyle = {
  button: {
    borderRadius: 'sm',
    border: '1px',
    fontWeight: 'semibold',
    letterSpacing: 'tight',
    _hover: {
      textDecoration: 'none'
    }
  }
};
var sizes = {
  md: {
    button: {
      fontSize: 'md',
      lineHeight: 'base',
      minWidth: '15.5rem !important'
    }
  },
  sm: {
    button: {
      fontSize: 'sm',
      lineHeight: 'short',
      minWidth: '5.25rem'
    }
  }
};
export var variantPrimary = {
  button: {
    bg: 'blue.600',
    borderColor: 'blue.600',
    color: 'white',
    _hover: {
      bg: 'blue.150',
      borderColor: 'blue.600',
      color: 'blue.600'
    },
    _focus: {
      bg: 'blue.900',
      borderColor: 'blue.300',
      boxShadow: "0px 0px 3px 2px #2182EB",
      color: 'white',
      outline: 'none'
    },
    _active: {
      bg: 'blue.900',
      borderColor: 'blue.300',
      boxShadow: "0px 0px 3px 2px #2182EB",
      color: 'white'
    },
    _disabled: {
      bg: 'grey.800',
      borderColor: 'grey.300',
      color: 'white',
      _hover: {
        bg: 'grey.800'
      }
    }
  }
};
export var variantSecondary = {
  button: {
    borderColor: 'blue.600',
    color: 'blue.600',
    _hover: {
      bg: 'blue.100',
      color: 'blue.600'
    },
    _focus: {
      bg: 'white',
      borderColor: 'blue.300',
      boxShadow: "0px 0px 3px 2px #2182EB",
      color: 'blue.600',
      outline: 'none'
    },
    _active: {
      bg: 'blue.900',
      borderColor: 'blue.300',
      color: 'white'
    },
    _disabled: {
      bg: 'white',
      borderColor: 'grey.300',
      color: 'grey.800',
      _hover: {
        backgroundColor: 'white'
      }
    }
  }
};
export var variantTab = {
  button: {
    bg: 'white',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: '4px solid',
    borderColor: 'grey.300',
    color: 'blue.600',
    _focus: {
      bg: 'blue.900',
      border: 'none',
      boxShadow: "0px 0px 3px 2px #2182EB",
      color: 'white',
      outline: 'none'
    },
    _active: {
      bg: 'blue.900',
      border: 'none',
      boxShadow: "0px 0px 3px 2px #2182EB",
      color: 'white'
    }
  }
};
export var variantDropDown = {
  button: {
    paddingLeft: '1rem',
    justifyContent: 'flex-start',
    color: 'black',
    fontWeight: 'normal',
    height: '2.9rem',
    borderColor: 'grey.450',
    bg: 'white',
    _hover: {
      bg: 'white',
      borderColor: 'grey.450'
    },
    _focus: {
      bg: 'white',
      borderColor: 'grey.450',
      boxShadow: "0px 0px 3px 2px #2182EB",
      color: 'black',
      outline: 'none'
    },
    _active: {
      bg: 'white',
      borderColor: 'grey.450',
      boxShadow: "0px 0px 3px 2px #2182EB",
      color: 'black'
    }
  }
};
export var Button = {
  baseStyle,
  variants: {
    primary: variantPrimary,
    secondary: variantSecondary,
    tab: variantTab,
    dropdown: variantDropDown
  },
  sizes
};